import { merge } from 'lodash'
import * as components from './components'
import { darkPalette } from './palette'
import { organizations } from './modules/organizations'

export const darkTheme = merge(
  { components },
  {
    palette: {
      ...darkPalette,
      organizations,
    },
  },
  { mode: 'dark' },
)
